var map = {
	"./utils/image/block.js": "./galaxy/modules/Canvas/resources/components/canvas/blocks/utils/image/block.js",
	"./utils/imageOrVideo/block.js": "./galaxy/modules/Canvas/resources/components/canvas/blocks/utils/imageOrVideo/block.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./galaxy/modules/Canvas/resources/components/canvas/blocks sync recursive ^((?%21admin).)*\\/block.(js%7Cvue)$";